/**
 * Episodes Container Component
 * Select current episode
 */
import React from 'react';
import {connect} from 'react-redux';

class EpisodesComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="episodes-component" >
        {this.props.children} {/* cf index.js: other nodes are nested in Route rendering AppComponent */}
      </div>
    );
  }
}

EpisodesComponent.defaultProps = {
  currentEpisodeId: 1
};

const mapStateToProps = function(store){
  return {
    currentEpisodeId: store.episodes.currentEpisodeId
  }
}

export default connect(mapStateToProps)(EpisodesComponent);



// WEBPACK FOOTER //
// ./src/components/Episodes.js